export function getNewTargetRanges(
  eligibilityUpdated: boolean,
  recurrenceUpdated: boolean,
  orderUpdated: boolean,
  lastOrderOfRecurrence: boolean,
  moreOrdersWillBeGenerated: boolean,
  OrderTexts: {
    getFutureOptionDisabledTooltip: () => string
    getAllOptionDisabledTooltip: () => string
    getFutureOptionDisabledForLastOccurrenceTooltip: () => string
    getOrderOptionHelperText: () => string
    getFutureOptionHelperText: () => string
    getAllOptionHelperText: () => string
  },
): uui.domain.ui.forms.RecurrenceCollectedTargetRange {
  if (eligibilityUpdated && !recurrenceUpdated && !orderUpdated) {
    return {
      ORDER: { visible: true, disabled: false },
      FUTURE: {
        visible: true,
        disabled: true,
        tooltip: OrderTexts.getFutureOptionDisabledTooltip(),
      },
      ALL: { visible: true, disabled: true, tooltip: OrderTexts.getAllOptionDisabledTooltip() },
    }
  }

  if (recurrenceUpdated && eligibilityUpdated) {
    return {
      ORDER: { visible: true, disabled: false, helperText: OrderTexts.getOrderOptionHelperText() },
      FUTURE: {
        visible: true,
        disabled: false,
        helperText: OrderTexts.getFutureOptionHelperText(),
      },
      ALL: { visible: true, disabled: false, helperText: OrderTexts.getAllOptionHelperText() },
    }
  }

  if (recurrenceUpdated && !orderUpdated) {
    return {
      ORDER: { visible: false, disabled: true },
      FUTURE: { visible: true, disabled: false },
      ALL: { visible: true, disabled: false },
    }
  }

  if (
    !eligibilityUpdated &&
    !recurrenceUpdated &&
    orderUpdated &&
    lastOrderOfRecurrence &&
    !moreOrdersWillBeGenerated
  ) {
    return {
      ORDER: { visible: true, disabled: false },
      FUTURE: {
        visible: true,
        disabled: true,
        tooltip: OrderTexts.getFutureOptionDisabledForLastOccurrenceTooltip(),
      },
      ALL: { visible: true, disabled: false },
    }
  }

  return {
    ORDER: {
      visible: true,
      disabled: false,
      helperText: recurrenceUpdated ? OrderTexts.getOrderOptionHelperText() : undefined,
    },
    FUTURE: { visible: true, disabled: false },
    ALL: { visible: true, disabled: false },
  }
}
